import React from "react";
import { Link } from "@/components/common/Link";
export default function Hero() {
  return <section data-section-id="225683" id="hero" className="relative w-full h-[400px] md:h-[500px] bg-background text-foreground" style={{
    background: "linear-gradient(135deg, #0B1F33 0%, #183A55 100%)"
  }}>
      <div className="absolute inset-0 flex items-center justify-center px-4 md:px-6 bg-gradient-to-br from-secondary/80 via-secondary/40 to-transparent">
        <div className="bg-secondary/30 backdrop-blur-md rounded-lg p-8 md:px-16 md:py-12 text-center max-w-4xl mx-auto shadow-2xl border border-white/20">
          <h1 className="text-3xl md:text-[60px] font-bold text-white font-default leading-tight tracking-tighter">
            Home Inspector in Miami-Dade County
          </h1>
          <p className="mt-4 text-lg md:text-xl text-white/90 font-default max-w-2xl mx-auto">
            Comprehensive property evaluations and certified safety inspections for South Florida homeowners.
          </p>
          <div className="mt-8">
            <Link to="https://trusted-fl.com/#schedule-your-inspection" className="inline-block bg-primary hover:bg-primary/90 text-primary-foreground px-8 py-3 rounded-md font-default font-semibold transition-colors shadow-lg">
              Schedule Your Inspection
            </Link>
          </div>
        </div>
      </div>
    </section>;
}